import { XMLBuilder, XMLParser } from "fast-xml-parser";
import z from "zod/v4";

const xmlParser = new XMLParser({
  ignoreAttributes: false,
  attributeNamePrefix: "",
  attributesGroupName: "attributes",
  processEntities: false,
});

const xmlBuilder = new XMLBuilder({
  ignoreAttributes: false,
  attributeNamePrefix: "",
  attributesGroupName: "attributes",
});

export const Xml = <T extends z.core.$ZodType>(schema: T) =>
  z.codec(z.string(), schema, {
    decode: (xmlString, ctx) => {
      try {
        return xmlParser.parse(xmlString) as z.input<T>;
      } catch (err: unknown) {
        ctx.issues.push({
          code: "invalid_format",
          format: "xml",
          input: xmlString,
          message: err instanceof Error ? err.message : undefined,
        });
        return z.NEVER;
      }
    },
    encode: (value) => xmlBuilder.build(value),
  });
